// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"d9219960","264":"9b683ebe","591":"88ca7a86","787":"f34198c3","984":"9d80ba6a"}[chunkId] + ".chunk.js";
};